import React from 'react';
import { Construction } from 'lucide-react';

const Games = () => {
  return (
    <div className="bg-gradient-to-r from-sky-50 via-sky-50/80 to-white min-h-screen pt-20">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="flex flex-col items-center justify-center text-center">
          <div className="bg-white/80 backdrop-blur-sm rounded-lg p-6 mb-6 border border-sky-200 hover:bg-white hover:border-sky-300 transition-all shadow-sm">
            <Construction className="w-16 h-16 text-sky-500" />
          </div>
          <h1 className="text-4xl font-bold text-sky-500 mb-4">
            Working on it
          </h1>
          <p className="text-gray-600 text-lg max-w-md">
            Our team is currently working on this feature.
            Check back soon for updates!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Games;